import { z } from "zod";
export const productRequestInput = z.object({
  title: z.string().trim().min(1),
  notes: z.string().trim().default(""),
});
export const productSupporterInput = z.object({
  email: z.string().trim().toLowerCase().pipe(z.email()),
  notes: z.string().trim().optional(),
});
export const productRequestCreate = productRequestInput.extend({
  supporters: z.array(productSupporterInput).default([]),
});
export const productRequestQuery = z.object({ q: z.string().trim().optional() });
export interface ProductSupporter {
  id: string;
  email: string;
  notes: string;
  createdAt: string;
}
export interface ProductRequest {
  id: string;
  title: string;
  notes: string;
  supporterCount: number;
  supporters: ProductSupporter[];
  createdAt: string;
  updatedAt: string;
}
export type ProductRequestInput = z.infer<typeof productRequestInput>;
export type ProductRequestCreate = z.infer<typeof productRequestCreate>;
export type ProductSupporterInput = z.infer<typeof productSupporterInput>;
type Json<T> = { content: { "application/json": T } };
type Id = { path: { id: string } };
type Empty = { 204: { content?: never } };
export interface ProductRequestPaths {
  "/product-requests": {
    get: {
      parameters: { query?: z.input<typeof productRequestQuery> };
      responses: { 200: Json<{ items: ProductRequest[] }> };
    };
    post: {
      requestBody: Json<z.input<typeof productRequestCreate>>;
      responses: { 201: Json<{ id: string }> };
    };
  };
  "/product-requests/{id}": {
    get: { parameters: Id; responses: { 200: Json<ProductRequest> } };
    put: {
      parameters: Id;
      requestBody: Json<z.input<typeof productRequestInput>>;
      responses: Empty;
    };
    delete: { parameters: Id; responses: Empty };
  };
  "/product-requests/{id}/supporters": {
    post: {
      parameters: Id;
      requestBody: Json<ProductSupporterInput>;
      responses: { 200: Json<{ id: string }> };
    };
  };
  "/product-requests/{id}/supporters/{supporterId}": {
    delete: { parameters: { path: { id: string; supporterId: string } }; responses: Empty };
  };
}
